import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SiteLayout from "@/components/site/SiteLayout";
import PublicPage from "@/pages/PublicPage";
import Login from "@/pages/admin/Login";
import AuthCallback from "@/pages/admin/AuthCallback";
import AdminLayout from "@/components/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import CalendarPage from "@/pages/admin/CalendarPage";
import Bookings from "@/pages/admin/Bookings";
import BookingDetail from "@/pages/admin/BookingDetail";
import Manifest from "@/pages/admin/Manifest";
import Boats from "@/pages/admin/Boats";
import Finance from "@/pages/admin/Finance";
import Invoices from "@/pages/admin/Invoices";
import InvoiceEditor from "@/pages/admin/InvoiceEditor";
import ContentEditor from "@/pages/admin/ContentEditor";
import Settings from "@/pages/admin/Settings";
import More from "@/pages/admin/More";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/admin/login" element={<Login />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="calendar" element={<CalendarPage />} />
        <Route path="bookings" element={<Bookings />} />
        <Route path="bookings/:id" element={<BookingDetail />} />
        <Route path="manifest" element={<Manifest />} />
        <Route path="boats" element={<Boats />} />
        <Route path="finance" element={<Finance />} />
        <Route path="invoices" element={<Invoices />} />
        <Route path="invoices/:id" element={<InvoiceEditor />} />
        <Route path="content" element={<ContentEditor />} />
        <Route path="settings" element={<Settings />} />
        <Route path="more" element={<More />} />
      </Route>
      <Route path="/" element={<SiteLayout />}>
        <Route index element={<PublicPage slug="home" />} />
        <Route path=":slug" element={<PublicPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}
